import { create } from "zustand";
import { persist } from "zustand/middleware";
import { getDefaultAuthState, getRestaurantState } from "../utils/store.helper";

const useUserStore = create(
  persist(
    (set) => ({
      ...getDefaultAuthState(),
      setUser: (userData, defaultBranch) => {
        const isSuperAdmin = userData?.isSuperAdmin || false;

        set({
          isLoggedIn: userData && userData.id !== "",
          user: {
            ...userData,
          },
          isSuperAdmin,
          ...getRestaurantState(userData, defaultBranch),
        });
      },
      clearUser: () => {
        set(getDefaultAuthState());
      },
      changeBranch: (branchData) => {
        set((state) => ({
          ...state,
          ...getRestaurantState(state.user, branchData),
        }));
      },
      updateSessionData: (branchData) => {
        set((state) => ({
          ...state,
          ...getRestaurantState(state.user, branchData),
        }));
      },
      updateTableCount: (newCount) => {
        set((state) => ({
          isQrTableSpecific: false,
          totalTableInRestaurant: newCount == 0 ? parseInt(newCount) + 1 : parseInt(newCount),
        }));
      },
      setNetworkCall: (val) => set({ networkCall: val }),
      setIsReloadNeeded: (val) => set({ isReloadNeeded: val }),
      setIsPayLater: (val) => set({ isPayLater: val }),
      setVatServiceCharge: (newValObj) =>
        set({
          restaurantVat: parseFloat(newValObj.restaurantVat),
          restaurantServiceCharge: parseFloat(newValObj.restaurantServiceCharge),
        }),
      setLoyaltyProgramSettings: (loyaltyProgramSettings) => set({ loyaltyProgramSettings }),
      setBranches: (newBranches) => set({ branches: newBranches }), // This will be updated on change inventory type in super admin
      showNotification: (text, isError = true) => {
        set((state) => ({ notifications: [{ text, isError, storedAt: Date.now() }] }));
      },
      clearNotification: () => {
        set((state) => ({ notifications: [] }));
      },
    }),
    {
      name: "auth-storage",
      getStorage: () => localStorage,
    }
  )
);

export default useUserStore;
